module.exports = __webpack_public_path__ + "static/media/hope1.f7fd66ee.jpg";